import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["Icon-svg"] || "Icon-svg"} viewBox="8 8 24 24" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="13" y="12" width="5" height="16" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" /><rect x="22" y="12" width="5" height="16" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>);